import React, { ReactElement } from 'react';
import NextHead from 'next/head';
import { ThemeEnum } from 'components/layouts/AppLayout';
import { getThemeVars } from 'utils/helpers/browser/theme';

interface Props {
    title: string;
    theme?: ThemeEnum;
}

const Head = ({ title, theme }: Props): ReactElement => {
    return (
        <NextHead>
            <title>{title}</title>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0"
            />
            {theme && (
                <style>{`:root, ::after, ::before {${getThemeVars(
                    theme
                )}}`}</style>
            )}
        </NextHead>
    );
};

export default Head;
